<template>
  <div class="item__info mx-5">
    <div class="text-center" v-if="!isLoading">
      <div class="divFotoProfilo">
        <img id="fotoProfilo" class="imgDivFotoProfilo" alt="Foto tesserato"
             :src="'http://www.federbridge.it/FotoAgonisti/' + playerCode + '.jpg'"
             onerror="this.src='http://www.federbridge.it/Mobile/Immagini/nofoto.jpg'">
      </div>
      <br>
      <br>
      <div class="col-md-12">
        <p>Ciao <strong>{{ playerName }}</strong></p>
      </div>

      <div class="contestInfo">
        <div class="row">
          <div class="col-md-12">
            Ti trovi all'evento<br>
            <span class="contestName">{{ tournamentName }}</span>
          </div>
          <div v-if="hasCollectorContest" class="col-md-12">
            <b-form-checkbox v-model="collectorSwitch" name="check-button" switch size="lg">Mostra nazionale
            </b-form-checkbox>
          </div>
        </div>
        <div class="row text-center">
          <template v-if="currentTableState != null && currentTableState.position > -1">
            <div class="col-md-12">
              Stai giocando il turno <strong>{{ currentRound }}</strong></div>
            <div class="col-md-12">
              La tua posizione attuale &egrave; al Tavolo <strong>{{ currentSectorSigla }} {{ currentTable }}
              {{ currentPosition }}</strong></div>
          </template>
          <template v-else-if="isPlaying && contestType === 0">
            <div class="col-md-12">
              <p>Al momento non sembra tu abbia un posto assegnato per il turno in corso</p>
              <table-subscribing class="my-5"></table-subscribing>
            </div>
          </template>
        </div>
      </div>
    </div>
    <PuSkeleton :count="5" v-else></PuSkeleton>

    <template v-if="!isLoading && (isTd || this.playerCode === 'VISITOR')">
      <div class="div-cont-table" v-for="sector of Object.values(sectors)" :key="sector.Sigla">
        <h5>Girone {{ sector.Sigla }} - {{ sector.Descrizione }}</h5>
        <div v-if="Math.max(...Object.keys(sector.Rounds).map(i => parseInt(i))) >= sector.CurrentRound">
          <div class="text-left">
            <div v-if="sector.JumpAfterRound > 0">
              <b-icon-skip-forward></b-icon-skip-forward>
              Salto a fine round
            </div>
            <div v-if="sector.ScrambleAfterRound > 0">
              <b-icon-arrow-left-right></b-icon-arrow-left-right>
              Scramble a fine round
            </div>
          </div>
          <div></div>
          <table class="w-100 table-girone mt-4">
            <tr>
              <td></td>
              <td v-for="roundNumber of visibleRounds(sector)"
                  :key="roundNumber"
                  class="turno-gioco align-bottom">
                <b-icon-skip-forward v-if="roundNumber === sector.JumpAfterRound"
                                     class="d-block m-auto"></b-icon-skip-forward>
                <b-icon-arrow-left-right v-if="roundNumber === sector.ScrambleAfterRound"
                                         class="d-block m-auto"></b-icon-arrow-left-right>
                {{ roundNumber }}
              </td>
            </tr>

            <tr v-for="[openRoomTableNumber, closedRoomTableNumber] of tablesOfSector(sector)"
                :key="openRoomTableNumber">
              <td class="tavolo-td">
                Tv {{ openRoomTableNumber }}
              </td>
              <td v-for="roundNumber of visibleRounds(sector)" :key="roundNumber">
                <table class="w-100">
                  <tr>

                    <td v-if="sector.Rounds[roundNumber].Tables[openRoomTableNumber] == null"></td>

                    <td v-else-if="sector.Rounds[roundNumber].Tables[openRoomTableNumber].IsBye"
                        class="bye-td">B
                    </td>

                    <template v-else>
                      <td :class="computeRoundClass(sector.Rounds[roundNumber].Tables[openRoomTableNumber])">
                        {{
                          sector.Rounds[roundNumber].Tables[openRoomTableNumber].PlayedBoards.length
                        }}
                      </td>
                      <template v-if="contestType === 0">
                        <td :class="computeRoundClass(sector.Rounds[roundNumber].Tables[closedRoomTableNumber])"
                            style="width: 50%"
                            v-html="closedRoomTableNumber !== undefined ? sector.Rounds[roundNumber].Tables[closedRoomTableNumber].PlayedBoards.length : '&nbsp;'">
                        </td>
                      </template>
                    </template>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div v-else style="font-size: 3rem" class="m-0"><b-icon-check variant="success"></b-icon-check></div>
      </div>
    </template>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TableSubscribing from "../components/bridgeSelection/TableSubscribing";

export default {
  name: 'Welcome',
  components: {TableSubscribing},
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    this.isLoading = this.players === null;
  },
  computed: {
    ...mapGetters({
      currentTableState: 'tournament/currentTableState',
      players: 'players/playersList',
      teamPlayers: 'players/teamPlayers',
      tournamentName: 'tournament/tournamentName',
      contestType: 'tournament/contestType',
      directors: 'tournament/directors',
      playerCode: 'webApp/playerCode',
      playerName: 'webApp/playerName',
      sectors: 'tournament/contestCurrentStateMap',
      isVisitor: 'webApp/isVisitor',
      isTd: 'webApp/isTd',
      isPlaying: 'webApp/isPlaying',
      useCollectorContest: 'webApp/useCollectorContest',
      hasCollectorContest: 'webApp/hasCollectorContest'
    }),
    collectorSwitch: {
      get() {
        return this.useCollectorContest;
      },
      set(newValue) {
        this.isLoading = true;
        this.changeContext(newValue);
      }
    },
    currentRound() {
      return this.currentTableState?.round;
    },
    currentTable() {
      return this.currentTableState?.table;
    },
    currentSectorSigla() {
      if (this.currentTableState == null || this.sectors.Phases == null) {
        return '';
      }
      return this.sectors.Phases[this.currentTableState.phase].Series[this.currentTableState.serie].Sessions[this.currentTableState.session].Groups[this.currentTableState.sector].Sigla;
    },
    currentPosition() {
      if (this.currentTableState == null || this.sectors.Phases == null) {
        return '';
      }
      return ['Nord', 'Est', 'Sud', 'Ovest'][this.currentTableState.position];
    }
  },
  methods: {
    ...mapActions({
      changeContext: 'webApp/changeContext',
    }),
    tablesOfSector(sector) {
      const allTables = Object.values(sector.Rounds).flatMap(rnd => Object.entries(rnd.Tables));

      const openRoomTablesNumber = [...new Set(allTables.filter(entry => entry[1].Room === 0)
          .map(t => parseInt(t)))]
          .sort((t1, t2) => t1 - t2);

      const closedRoomTablesNumber = [...new Set(allTables.filter(entry => entry[1].Room === 1)
          .map(t => parseInt(t)))]
          .sort((t1, t2) => t1 - t2);

      //Array.zip
      const zip = (a, b) => Array.from(Array(Math.max(b.length, a.length)), (_, i) => [a[i], b[i]]);

      //[openRoomTableNumber, closedRoomTableNumber]
      return zip(openRoomTablesNumber, closedRoomTablesNumber);
    },
    computeRoundClass(round) {
      switch (round?.PlayedBoards?.length ?? -1) {
        case -1:
          return "";
        case 0:
          return "red-td";
        case round.Boards.length:
          return "green-td";
        default:
          return "yellow-td"
      }
    },
    visibleRounds(sector) {
      //  pairs contest -> pre pre pre curr post post post
      //  teams contest -> pre curr post
      const prePostColumns = this.contestType === 0 ? 1 : 2;
      const allRounds = Object.keys(sector.Rounds).map(i => parseInt(i)).sort();

      if (allRounds.length <= prePostColumns * 2 + 1) {
        return allRounds;
      }

      const minRound = Math.min(...allRounds);
      const maxRound = Math.max(...allRounds);
      const currentRound = sector.CurrentRound;
      let startFrom = Math.max(currentRound - prePostColumns, minRound);

      if (startFrom + (prePostColumns * 2) > maxRound) {
        startFrom = maxRound - (prePostColumns * 2);
      }

      return Array.from({length: prePostColumns * 2 + 1}, (_, i) => i + startFrom);
    }
  },
  watch: {
    players() {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.text-message {
  margin-bottom: 30px;
}

.div-cont-table {
  padding-bottom: 50px;
  border-bottom: 1px solid grey;
  margin-top: 20px;
  text-align: center;
}

td {
  max-width: 20px;
  height: 20px;
}

.table-girone tr {
  border-bottom: 2px solid white;
}

.table-girone {
  overflow-y: scroll;
}

.turno-gioco {
  font-weight: 600;
}

.red-td {
  background-color: #d91919;
  color: white;
}

.contestName {
  color: #3396B8;
  //color: #1B708D;
  font-weight: bold;
}

.yellow-td {
  background-color: yellow;
}

.bye-td {
  background-color: goldenrod;
}

.green-td {
  background-color: #d4edda;
}

td.tavolo-td {
  padding-right: 3px;
  white-space: nowrap;
  text-align: right;

}

.divFotoProfilo {
  z-index: 0;
  height: 100px;
  width: 100px;
  position: relative;
  border-radius: 100%;
  border: 1px solid #3396B8;
  overflow: hidden;
  margin: 0 auto;
}

.imgDivFotoProfilo {
  z-index: 1;
  position: absolute;
  left: -50%;
  right: -50%;
  top: 0;
  margin: auto;
  height: 120px;
  border: 0;
}
</style>
